/**
 * 1. Огноог тодорхой форматаар харуулах
 *   Жишээ нь: "2025-06-05T14:30:00.000Z" → "2025-06-05 14:30"
 */
export function formatDateTime(dateInput, { locale = "mn-MN", options } = {}) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date)) return "";

  // Улиралын өгөгдлийг өөрчлөхгүйгээр форматлах үндсэн сонголтууд:
  const defaultOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formatOptions = options || defaultOptions;
  return new Intl.DateTimeFormat(locale, formatOptions).format(date);
}

/**
 * 2. Огноог зөвхөн өдөр гэсэн форматаар харуулах
 *   Жишээ: formatDate("2025-06-05T14:30:00.000Z") → "2025-06-05"
 */
export function formatDate(dateInput) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date)) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * 3. Огноог зөвхөн цаг, минут хэлбэрээр харуулах
 *   Жишээ: formatTime("2025-06-05T14:30:00.000Z") → "14:30"
 */
export function formatTime(dateInput) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date)) return "";
  const hh = String(date.getHours()).padStart(2, "0");
  const mi = String(date.getMinutes()).padStart(2, "0");
  return `${hh}:${mi}`;
}

/**
 * 4. Төгрөг рүү хөрвүүлэх функц
 *   Жишээ: formatCurrency(1000) → "1,000₮"
 */
export function formatCurrency(amount) {
  const formattedNumber = parseInt(amount).toLocaleString("mn-MN");
  return `${formattedNumber}₮`;
}

/**
 * 5. Текстийн эхний үсгийг томоор хөрвүүлэх
 *   Жишээ: capitalize("hello world") → "Hello world"
 */
export function capitalize(text) {
  if (typeof text !== "string" || text.length === 0) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * 6. Мөр огтлогч (truncate) функц
 *   Жишээ: truncate("…урт текст…", 10) → "…урт тек…"
 */
export function truncate(text, maxLength = 100, ellipsis = "...") {
  if (typeof text !== "string") return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + ellipsis;
}

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.toLowerCase());
}
